import { matchesBrandHostname } from './brand'

const DEFAULT_EDUMIAM_HOSTNAMES = 'inscription.edumiam.com'

export type AppThemeKey = 'edumiam' | 'sante' | 'default'

type FeatureFlagsEnv = {
  VITE_FEATURE_IPERIA_BI_SALES_FORM?: string
  VITE_INSCRIPTION_EDUMIAM_HOSTNAMES?: string
}

let featureFlagsEnv: FeatureFlagsEnv | null = null

export function setFeatureFlagsEnv(env: FeatureFlagsEnv): void {
  featureFlagsEnv = env
}

function getEnv(): FeatureFlagsEnv {
  if (featureFlagsEnv) return featureFlagsEnv
  if (typeof process !== 'undefined' && process.env.JEST_WORKER_ID !== undefined) {
    return process.env as FeatureFlagsEnv
  }
  return {
    VITE_FEATURE_IPERIA_BI_SALES_FORM: 'false',
    VITE_INSCRIPTION_EDUMIAM_HOSTNAMES: DEFAULT_EDUMIAM_HOSTNAMES,
  }
}

export function parseEdumiamHostnames(raw: string | undefined): string[] {
  const value = raw ?? DEFAULT_EDUMIAM_HOSTNAMES
  return value
    .split(',')
    .map((hostname) => hostname.trim())
    .filter(Boolean)
}

export function isEdumiamHostnameForHostnames(hostname: string, configuredHostnames: string[]): boolean {
  return configuredHostnames.some((configuredHostname) =>
    matchesBrandHostname(hostname, configuredHostname),
  )
}

function getEdumiamHostnames(): string[] {
  return parseEdumiamHostnames(getEnv().VITE_INSCRIPTION_EDUMIAM_HOSTNAMES)
}

export function isFeatureFlagEnabled(flag: string | undefined): boolean {
  return flag === 'true'
}

export function isIperiaBiChannelEnabled(): boolean {
  return isFeatureFlagEnabled(getEnv().VITE_FEATURE_IPERIA_BI_SALES_FORM)
}

export function isEdumiamHostname(hostname: string = window.location.hostname): boolean {
  return isEdumiamHostnameForHostnames(hostname, getEdumiamHostnames())
}

export function isIperiaRoute(pathname: string): boolean {
  return pathname.includes('/iperia/')
}

export function resolveAppTheme(
  pathname: string,
  edumiamHostname: boolean,
  iperiaBiChannelEnabled: boolean,
): AppThemeKey {
  if (iperiaBiChannelEnabled && (edumiamHostname || isIperiaRoute(pathname))) return 'edumiam'
  if (pathname.includes('/sante/')) return 'sante'
  return 'default'
}
